import React from 'react';
import styles from './sortableColumnHeader.module.css';

export type SortDirection = 'asc' | 'desc' | null;

interface SortableColumnHeaderProps {
  label: string;
  columnKey: string;
  sortKey: string | null;
  sortDirection: SortDirection;
  onSort: (key: string) => void;
  className?: string;
  /** Which side of the label the sort icon renders on (default: 'left'). */
  iconPosition?: 'left' | 'right';
}

const SortableColumnHeader: React.FC<SortableColumnHeaderProps> = ({
  label,
  columnKey,
  sortKey,
  sortDirection,
  onSort,
  className,
  iconPosition = 'left',
}) => {
  const isActive = sortKey === columnKey;

  const icon = (
    <span className={`${styles.sortIcon} ${iconPosition === 'right' ? styles.sortIconRight : ''}`} aria-hidden="true">
      <span className={`${styles.triangleUp} ${isActive && sortDirection === 'asc' ? styles.triangleActive : ''}`} />
      <span className={`${styles.triangleDown} ${isActive && sortDirection === 'desc' ? styles.triangleActive : ''}`} />
    </span>
  );

  return (
    <th
      className={`${styles.sortableHeader} ${isActive ? styles.active : ''} ${className || ''}`}
      onClick={() => onSort(columnKey)}
    >
      <span className={styles.inner}>
        {iconPosition === 'left' && icon}
        <span className={styles.label}>{label}</span>
        {iconPosition === 'right' && icon}
      </span>
    </th>
  );
};

export default SortableColumnHeader;
